module.exports = function($scope) {

  var vm = this;

  function init() {
    $scope.message = $scope.ngDialogData.message;
    vm.funderName = $scope.ngDialogData.fundingOfferFunder;
    vm.signedTermsDocument = { id: null, fileName: null, fileSize: null };
    vm.termsDocumentType = $scope.ngDialogData.termsDocumentType;
  }

  $scope.ok = function() {
    $scope.closeThisDialog({
      action: "ok",
      uploadSignedTermsDoc: vm.uploadSignedTermsDoc,
      signedTermsDocument: vm.signedTermsDocument
    });
  }

  $scope.cancel = function() {
    $scope.closeThisDialog({action:"cancel"})
  }

  init();
}
